import { BaseModel } from './base';

export class TypeOfWire extends BaseModel {
  WireTypeName: string;
  SubscriberId: string;
  SiteId: string;
  id: string;
}
